module.exports = __webpack_public_path__ + "img/1440.10f53166.jpg";